/* De Goede Stap — productkaarten: kleur wisselen en snel toevoegen (overal op de site). */
(function () {
  if (window.__dgsQuick) return;
  window.__dgsQuick = true;

  var money = function (c) { return '€' + (c / 100).toFixed(2).replace('.', ','); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var isSize = function (n) { return /maat|size/i.test(n || ''); };
  var isColor = function (n) { return /kleur|colou?r/i.test(n || ''); };
  var abs = function (u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u || ''; };
  var sized = function (u, w) { u = abs(u); return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };
  var X = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  var sheet = null, qBody, qBtn, state = null;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('dialog');
    sheet.className = 'dgs-sheet dgs-sheet--quick';
    sheet.setAttribute('aria-label', 'Snel toevoegen');
    sheet.innerHTML =
      '<div class="dgs-sheet__inner">' +
      '<div class="dgs-sheet__head"><h2>Kies uw maat</h2><button type="button" class="dgs-sheet__close" data-close aria-label="Sluiten">' + X + '</button></div>' +
      '<div class="dgs-sheet__body" data-quick-body></div>' +
      '<div class="dgs-sheet__foot"><button type="button" class="dgs-sheet__cta" data-quick-add disabled>Kies eerst uw maat</button></div>' +
      '</div>';
    document.body.appendChild(sheet);
    qBody = sheet.querySelector('[data-quick-body]');
    qBtn = sheet.querySelector('[data-quick-add]');
    sheet.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-close]')) sheet.close();
    });
    qBody.addEventListener('click', function (e) {
      var c = e.target.closest('[data-color]');
      if (c) {
        state.color = c.dataset.color;
        if (state.variant && state.sizeIdx > -1) {
          var size = state.variant.options[state.sizeIdx];
          state.variant = state.p.variants.find(function (v) {
            return v.options[state.colorIdx] === state.color && v.options[state.sizeIdx] === size && v.available;
          }) || null;
        }
        render();
        return;
      }
      var s = e.target.closest('[data-vid]');
      if (s) {
        state.variant = state.p.variants.find(function (v) { return String(v.id) === s.dataset.vid; });
        render();
      }
    });
    qBtn.addEventListener('click', add);
    return sheet;
  }

  function render() {
    var p = state.p, sIdx = state.sizeIdx, cIdx = state.colorIdx;
    var colors = [];
    if (cIdx > -1) p.variants.forEach(function (v) {
      var c = v.options[cIdx];
      if (!colors.some(function (x) { return x.name === c; })) colors.push({ name: c, img: v.featured_image ? v.featured_image.src : '' });
    });
    var pool = cIdx > -1 ? p.variants.filter(function (v) { return v.options[cIdx] === state.color; }) : p.variants;
    var cur = state.variant || pool.find(function (v) { return v.available; }) || pool[0];
    var img = (cur && cur.featured_image && cur.featured_image.src) || p.featured_image || '';
    var h = '<div class="dgs-q__prod">' + (img ? '<img src="' + esc(sized(img, 200)) + '" alt="">' : '') +
      '<div><div class="dgs-q__name">' + esc(p.title) + '</div><div class="dgs-q__price">' +
      (cur.compare_at_price > cur.price ? '<s>' + money(cur.compare_at_price) + '</s>' : '') + money(cur.price) + '</div></div></div>';
    if (colors.length > 1) {
      h += '<p class="dgs-q__label">Kleur: <span>' + esc(state.color) + '</span></p><div class="dgs-q__colors">' + colors.map(function (c) {
        return '<button type="button" class="dgs-q__color' + (c.name === state.color ? ' is-active' : '') + '" data-color="' + esc(c.name) + '" aria-label="' + esc(c.name) + '">' +
          (c.img ? '<img src="' + esc(sized(c.img, 120)) + '" alt="">' : esc(c.name)) + '</button>';
      }).join('') + '</div>';
    }
    if (sIdx > -1) {
      h += '<p class="dgs-q__label">Maat' + (state.variant ? ': <span>' + esc(state.variant.options[sIdx]) + '</span>' : '') + '</p><div class="dgs-q__sizes">' + pool.map(function (v) {
        return '<button type="button" class="dgs-q__size' + (state.variant && state.variant.id === v.id ? ' is-active' : '') + '" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.options[sIdx]) + '</button>';
      }).join('') + '</div>';
    }
    h += '<p class="dgs-q__err" data-q-err hidden></p><a class="dgs-q__link" href="' + esc(state.url) + '">Bekijk alle details van dit model</a>';
    qBody.innerHTML = h;
    if (sIdx === -1 && !state.variant) state.variant = cur;
    qBtn.disabled = !state.variant;
    qBtn.textContent = state.variant ? 'In winkelmand · ' + money(state.variant.price) : 'Kies eerst uw maat';
  }

  function add() {
    if (!state || !state.variant) return;
    qBtn.disabled = true;
    qBtn.textContent = 'Bezig met toevoegen…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: state.variant.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var er = qBody.querySelector('[data-q-err]');
          if (er) { er.textContent = res.j.description || 'Toevoegen lukte niet. Probeer het opnieuw.'; er.hidden = false; }
          qBtn.disabled = false; qBtn.textContent = 'Probeer opnieuw';
          return;
        }
        sheet.close();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'dgs-product' } }));
      })
      .catch(function () { qBtn.disabled = false; qBtn.textContent = 'Probeer opnieuw'; });
  }

  document.addEventListener('click', function (e) {
    /* kleur op de kaart */
    var sw = e.target.closest('[data-pc-sw]');
    if (sw) {
      var card = sw.closest('[data-pc]');
      card.querySelectorAll('[data-pc-sw]').forEach(function (b) { b.classList.toggle('is-active', b === sw); });
      var img = card.querySelector('.dgs-pc__im');
      if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; }
      if (sw.dataset.url) card.querySelectorAll('[data-pc-link]').forEach(function (a) { a.href = sw.dataset.url; });
      return;
    }
    /* snel toevoegen */
    var q = e.target.closest('[data-pc-quick]');
    if (!q) return;
    e.preventDefault();
    var c = q.closest('[data-pc]');
    var link = c.querySelector('[data-pc-link]');
    var activeSw = c.querySelector('[data-pc-sw].is-active');
    ensureSheet();
    qBody.innerHTML = '<p class="dgs-q__loading">Even laden…</p>';
    qBtn.disabled = true; qBtn.textContent = 'Kies eerst uw maat';
    if (!sheet.open) { sheet.showModal(); document.documentElement.style.overflow = 'hidden'; }
    fetch('/products/' + c.dataset.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var sIdx = p.options.findIndex(function (o) { return isSize(o.name || o); });
      var cIdx = p.options.findIndex(function (o) { return isColor(o.name || o); });
      var color = null;
      if (cIdx > -1) {
        var wanted = activeSw ? activeSw.getAttribute('aria-label') : null;
        var first = p.variants.find(function (v) { return v.available && (!wanted || v.options[cIdx] === wanted); }) ||
          p.variants.find(function (v) { return v.available; }) || p.variants[0];
        color = first.options[cIdx];
      }
      state = { p: p, sizeIdx: sIdx, colorIdx: cIdx, color: color, variant: null, url: link ? link.href : p.url };
      if (sIdx === -1 && cIdx === -1) state.variant = p.variants.find(function (v) { return v.available; }) || null;
      render();
    }).catch(function () { window.location.href = link ? link.href : '/'; });
  });
})();
